import React from "react";
import {
    Flex
} from "@chakra-ui/react";


import Hero from "../components/Hero";
import CardGrid from "../components/CardGrid";
import TextFlex from "../components/TextFlex";
import ImageGrid from "../components/ImageGrid";

import classes from "../data/classes.json";
import images from "../data/images.json"


export default function Home() {
    return (
        <>
            <Hero />

            <TextFlex>
                <Flex flexDirection={"column"}>
                    <h1>What</h1>
                    <p>Computer graphics is the field that studies the creation and manipulation of visual content on a computer. This includes images, animations, graphs, websites, movies, and more.</p>
                </Flex>
                <Flex flexDirection={"column"}>
                    <h1>Why</h1>
                    <p>Computer graphics is used in entertainment, education, data visualization, and computer aided design. It provides an intuitive way for people to interact with data and computers.</p>
                </Flex>
                <Flex flexDirection={"column"}>
                    <h1>How</h1>
                    <p>Our club provides workshops where you can explore and learn how to use computer graphics techniques such as shaders, 3D models, ray tracing, and rasterization.</p>
                </Flex>
            </TextFlex>

            <CardGrid items={classes} title={"Recommended Classes"} />
        </>
    );
}
